import { AttributesDropdownProps } from '../service/attributes.interface';

export const buttonActionText = 'Распределить с помощью ИИ';

export const initialFilters = {
    limit: 10,
    offset: 0,
    page: 1,
};

export const dropdownItems: AttributesDropdownProps[] = [
    {
        label: 'В начало',
        key: 'to-start',
    },
    {
        label: 'В конец',
        key: 'to-end',
    },
];
